module.exports = __webpack_public_path__ + "img/image9.894c0523.png";